import React from "react";
import { Slide } from "react-reveal";

const WhyNEXUS = () => {
  return (
    <section className="threads-bg">
      <div className="large">
        <div className="section-content-container">
          <div className="why-cards-container flex">
            <Slide left>
              <div className="why-card">
                <h3>WHO WE ARE</h3>
                <p>
                  Nexus Events Uganda, a leading and one-stop events planner and
                  production company.
                </p>
              </div>
            </Slide>
            <Slide top>
              <div className="why-card">
                <h3>WHY NEXUS EVENTS</h3>
                <p>
                  We have planned and produced 70% of Kampala's top and high-end
                  events since 2019.
                </p>
              </div>
            </Slide>
            <Slide right>
              <div className="why-card">
                <h3>WHERE TO FIND US</h3>
                <p>Kiwatule-Mbogo Road, at Nexus Lounge.</p>
              </div>
            </Slide>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyNEXUS;
